import { writable, derived } from 'svelte/store';

import { countryCol, categoryCol, weightCol } from './config';
import { getCategoryByKey, sortByKey, getMapTransform } from './utils';

export const selectedProduct = writable(null);
export const activeCategory = writable(null);
export const activeCountry = writable(null);
export const data = writable([]);
export const funfacts = writable([]);
export const mapTransform = writable(getMapTransform());

export const activeCategoryItem = derived(activeCategory, ($activeCategory) =>
  getCategoryByKey($activeCategory)
);

const getDataForCategory = (data, category) =>
  data.reduce((res, item) => {
    res[item[countryCol]] = res[item[countryCol]]
      ? res[item[countryCol]]
      : { weight: 0 };

    if (!category || (category && item[categoryCol] === category)) {
      res[item[countryCol]].weight += item[weightCol];
    }

    return res;
  }, {});

export const bubbleMapData = derived(
  [data, activeCategory],
  ([$data, $activeCategory]) => getDataForCategory($data, $activeCategory),
  {}
);

export function getExtent(data, dataKey) {
  const values = Object.keys(data).map((key) => data[key][dataKey]);
  return [Math.min(...values), Math.max(...values)];
}

export const weightExtent = derived(
  data,
  ($data) => {
    const catData = getDataForCategory($data, null);
    return getExtent(catData, 'weight');
  },
  [0, 0]
);

export const weightSum = derived(
  [data, activeCategory],
  ([$data, $activeCategory]) => {
    const count = $data.reduce((res, item) => {
      if (
        !$activeCategory ||
        ($activeCategory && item[categoryCol] === $activeCategory)
      ) {
        res += item[weightCol];
      }

      return res;
    }, 0);

    return count;
  },
  0
);

export const countryProducts = derived(
  [activeCountry, activeCategory, data],
  ([$activeCountry, $activeCategory, $data]) => {
    const products = $data
      .filter((d) => d[countryCol] === $activeCountry)
      .filter((d) => !$activeCategory || d[categoryCol] === $activeCategory)
      .sort(sortByKey(weightCol, false))
      .map((d, i) => ({
        ...d,
        rank: i + 1,
      }));

    return products;
  },
  []
);
